import React from 'react';
import { MonitorSmartphone, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * LiveStreamUnsupportedNotice — shown inside a live video tile when the current
 * browser/device can decode NEITHER via WebCodecs NOR via classic MediaSource
 * (e.g. iPhone Safari below iOS 16.4). Replaces the cryptic "WebCodecs
 * unavailable / Decoder could not start" overlay with a clear, branded message
 * and an explicit "Try anyway" escape hatch in case detection is wrong.
 */
export const LiveStreamUnsupportedNotice = ({ label = null, onRetry }) => (
  <div
    className="absolute inset-0 z-20 flex items-center justify-center bg-black/85 px-4"
    data-testid="live-unsupported-notice"
  >
    <div className="text-center text-white max-w-xs">
      <MonitorSmartphone className="w-9 h-9 mx-auto mb-3 text-amber-400" />
      <p className="text-sm font-medium" data-testid="live-unsupported-title">
        Live view not supported on this device
      </p>
      <p className="text-xs text-white/60 mt-1.5 leading-relaxed">
        This browser can&rsquo;t decode the live video stream. Update to iOS&nbsp;16.4
        or newer, or open the platform on a desktop browser to watch live.
      </p>
      {label && (
        <p className="text-[11px] text-white/40 mt-2 truncate" data-testid="live-unsupported-label">{label}</p>
      )}
      {onRetry && (
        <Button
          size="sm"
          variant="outline"
          onClick={onRetry}
          className="mt-3 h-8 text-xs bg-white/10 border-white/20 text-white hover:bg-white/20 pointer-events-auto"
          data-testid="live-unsupported-retry"
        >
          <RefreshCw className="w-3.5 h-3.5 mr-1.5" /> Try anyway
        </Button>
      )}
    </div>
  </div>
);

export default LiveStreamUnsupportedNotice;
